export default __webpack_public_path__ + "static/media/illustration-algostudy-n-m@2x.db675de4.png";